import Web3 from 'web3';

export const NO_METAMASK_EXCEPTION = 'NO_METAMASK_EXCEPTION';

let Web3StatusService = new Promise(function (resolve, reject) {
  // Wait for loading completion to avoid race conditions with web3 injection timing.
  window.addEventListener('load', function () {
    let results;
    let web3 = window.web3;

    // Checking if Web3 has been injected by the browser (Mist/MetaMask)
    if (typeof web3 !== 'undefined') {
      let oldWeb3 = web3;

      // Use Mist/MetaMask's provider.
      web3 = new Web3(web3.currentProvider);

      results = {
        web3: web3,
        oldWeb3: oldWeb3
      };

      resolve(results);
    } else {
      reject(NO_METAMASK_EXCEPTION);
    }
  });
});

export default Web3StatusService;



// WEBPACK FOOTER //
// ./src/utils/Web3StatusService.js